import React from "react";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/shared/utils";
import { ChevronRight, Zap, Users, Building2, Receipt } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function DrillDownBreadcrumb({ engine, reseller, merchant, transaction }) {

  let t = null;
  try {
    const langContext = useLanguage();
    t = langContext?.t;
  } catch (e) {
    // Not wrapped in LanguageProvider
  }

  const items = [];

  if (engine && engine.id) {
    items.push({
      label: engine.name || engine.code || (t ? t("engine") : "Engine"),
      icon: Zap,
      href: createPageUrl("AdminEngineDetail") + `?id=${engine.id}`,
      color: "bg-blue-800 text-blue-300",
    });
  }

  if (reseller && reseller.id) {
    items.push({
      label: reseller.name || reseller.code || (t ? t("reseller") : "Reseller"),
      icon: Users,
      href: createPageUrl("AdminResellerDetail") + `?id=${reseller.id}`,
      color: "bg-purple-800 text-purple-300",
    });
  }

  if (merchant && merchant.id) {
    items.push({
      label: merchant.name || merchant.code || (t ? t("merchant") : "Merchant"),
      icon: Building2,
      href: createPageUrl("AdminMerchantDetail") + `?id=${merchant.id}`,
      color: "bg-blue-700 text-blue-200",
    });
  }

  if (transaction) {
    items.push({
      label: transaction.transaction_id || (t ? t("transaction") : "Transaction"),
      icon: Receipt,
      href: null,
      color: "bg-green-800 text-green-300",
    });
  }

  if (items.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap bg-[#0b1b33] rounded-lg px-4 py-2 border border-[#11264f]">
      <span className="text-xs text-blue-300 font-medium uppercase">{t ? t("hierarchy") : "Hierarchy"}:</span>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight className="h-4 w-4 text-blue-400" />}
          {item.href ? (
            <Link
              to={item.href}
              className="flex items-center gap-1.5 px-2 py-1 rounded-md hover:bg-[#11264f] hover:text-white transition-colors duration-200"
            >
              <div className={`w-5 h-5 rounded flex items-center justify-center ${item.color}`}>
                <item.icon className="h-3 w-3" />
              </div>
              <span className="text-sm font-medium">{item.label}</span>
            </Link>
          ) : (
            <div className="flex items-center gap-1.5 px-2 py-1">
              <div className={`w-5 h-5 rounded flex items-center justify-center ${item.color}`}>
                <item.icon className="h-3 w-3" />
              </div>
              <span className="text-sm font-medium text-blue-200">{item.label}</span>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
